import {Form} from "react-bootstrap";
import {useTranslation} from "react-i18next";

/**
 * Component for selecting a language
 */
interface LocaleSelectorProps {
    className?: string
}

export const LocaleSelector = ({className} : LocaleSelectorProps) =>
{
    const {i18n} = useTranslation();

    const supportedLanguages = ["de", "dk", "en", "es", "fi", "fr", "it", "ja", "ko", "nl", "no", "pl", "pt", "ro", "sv", "tr"]

    return (
        <Form.Select aria-label="Select Language" className={className} size="sm"
            value={i18n.resolvedLanguage ?? "en"}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
            {supportedLanguages.map(name => (
                <option value={name} key={name}>
                    {name}
                </option>
            ))}
        </Form.Select>
    );
};
